module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_location_photowedding-1fd97d77643c8ef7463778d66f9cecb3.webp";